const COMMENTS_MODAL_URL = 'comments';
const MODAL_SEARCH_PARAM_KEY = 'showModal';
const COMMENTS_MODAL_SEARCH_PARAM_VALUE = 'comments';

export {
  COMMENTS_MODAL_URL,
  MODAL_SEARCH_PARAM_KEY,
  COMMENTS_MODAL_SEARCH_PARAM_VALUE
};
